import React, { FunctionComponent, useState, useEffect, Dispatch } from "react";
import { connect, ConnectedProps } from "react-redux";
import SearchInput from "../../common/Form/SearchInput";
import { leaveGame, enterGame } from "../../../redux/actions/GameActions";
import {
  ListItem,
  ListItemText,
  List,
  ListItemSecondaryAction,
  IconButton
} from "@material-ui/core";
import CenteredLoader from "../../common/CenteredLoader";
import LeaveGameButton from "../LeaveGameButton";
import { database } from "../../../App";
import PlayArrowTwoToneIcon from "@material-ui/icons/PlayArrowTwoTone";
import {
  ProfileInterface,
  ProfileInfo
} from "../../../redux/reducers/ProfileReducers";
import UserIcon from "../../profile/UserIcon";
import { GameInterface, GameInfo } from "../../../redux/reducers/GameReducers";
import { FriendsInterface } from "../../../redux/reducers/FriendsReducers";
import { ExpansionInterface } from "../../../redux/reducers/ExpansionsReducers";
import { AuthInterface } from "../../../redux/reducers/AuthReducers";
import ListItemIcon from "@material-ui/core/ListItemIcon";

interface actionsType {
  leaveGame: (
    playerID: string,
    gameId: string,
    parentStatus: string
  ) => (
    dispatch: Dispatch<{
      type: string;
    }>
  ) => void;
  enterGame: (
    gameId: string
  ) => (
    dispatch: Dispatch<{
      type: string;
    }>
  ) => void;
}
interface RootState {
  profile: ProfileInterface;
  game: GameInterface;
  friends: FriendsInterface;
  expansion: ExpansionInterface;
  auth: AuthInterface;
}

const actionsReducers: actionsType = {
  leaveGame,
  enterGame
};

const mapStateToProps = (state: RootState) => ({
  auth: state.auth,
  profile: state.profile,
  friends: state.friends,
  expansion: state.expansion,
  game: state.game
});

const connector = connect(mapStateToProps, actionsReducers);

type PropsFromRedux = ConnectedProps<typeof connector>;

interface SearchGameProps {}

interface GameModerator {
  moderator: ProfileInfo;
}
type GameInfoWithModerator = GameModerator & GameInfo;

const SearchGame: FunctionComponent<SearchGameProps &
  PropsFromRedux> = props => {
  const [search, setSearch] = useState("");
  const [searching, setSearching] = useState(true);
  const [searched, setSearched] = useState(false);
  const [gamesSearched, setGamesSearched] = useState(
    [] as GameInfoWithModerator[]
  );
  function handleSearchGame(event: any) {
    setSearch(event.target.value);
  }

  useEffect(() => {
    let cancelRequest = false;
    if (!cancelRequest) {
      setSearching(true);
    }
    if (!cancelRequest) {
      setSearched(false);
    }
    database
      .ref("games")
      .child("created")
      .orderByChild("status")
      .startAt("room")
      .limitToLast(20)
      .on("value", function(snapshot) {
        if (snapshot.val()) {
          let array: GameInfoWithModerator[] = [];
          Object.keys(snapshot.val()).forEach((key: any) => {
            if (
              !cancelRequest &&
              snapshot.val()[key].currentPlayers <
                snapshot.val()[key].maxPlayers
            ) {
              database
                .ref("users")
                .child(snapshot.val()[key].moderator)
                .child("profile")
                .on("value", username => {
                  array = [
                    ...array,
                    {
                      ...snapshot.val()[key],
                      moderator: username.val()
                    }
                  ];
                  if (!cancelRequest) {
                    setGamesSearched(array);
                  }
                });
            }
          });
        } else {
          if (!cancelRequest) {
            setGamesSearched([]);
          }
        }
        if (!cancelRequest) {
          setSearching(false);
        }
        if (!cancelRequest) {
          setSearched(false);
        }
      });
    return () => {
      cancelRequest = true;
    };
  }, [props.game]);

  function searchGamePress(e: any) {
    if (e.key === "Enter") {
      searchGame(search);
    }
  }

  function handleEnterToGame(gameId: string) {
    if (props.game.playing) {
      return alert("You already in a game!");
    }
    props.enterGame(gameId);
    window.location.assign("#/game");
  }

  function searchGame(newSearch: string) {
    setSearching(true);
    setSearched(false);
    database
      .ref("games")
      .child("created")
      .orderByChild("gameName")
      .startAt(newSearch)
      .endAt(`${newSearch}\uf8ff`)
      .limitToLast(20)
      .on("value", function(snapshot) {
        if (snapshot.val()) {
          let array: GameInfoWithModerator[] = [];
          Object.keys(snapshot.val()).forEach((key: any) => {
            if (snapshot.val()[key].status === "room") {
              database
                .ref("users")
                .child(snapshot.val()[key].moderator)
                .child("profile")
                .child("username")
                .on("value", username => {
                  array = [
                    ...array,
                    {
                      ...snapshot.val()[key],
                      moderator: username.val()
                    }
                  ];
                  setGamesSearched(array);
                });
            }
          });
        } else {
          setGamesSearched([]);
        }
        setSearching(false);
        setSearched(Boolean(newSearch));
      });
  }

  function renderSearch() {
    return gamesSearched.length > 0 ? (
      <List style={{ maxHeight: "calc(100vh - 280px)", overflowY: "auto" }}>
        {gamesSearched.map((game: GameInfoWithModerator, index: number) => (
          <ListItem
            onClick={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) =>
              handleEnterToGame(game.id)
            }
            button
            key={index}
          >
            <ListItemIcon>
              <UserIcon url={game.moderator.userpic} height="50" width="50" />
            </ListItemIcon>
            <ListItemText
              primary={`${game.gameName} (${game.currentPlayers}/${game.maxPlayers})`}
              secondary={`${game.moderator.username} using ${game.cards.length} cards`}
            />
            <ListItemSecondaryAction>
              <IconButton edge="end" aria-label="play">
                <PlayArrowTwoToneIcon fontSize="large" />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
        ))}
      </List>
    ) : searched ? (
      <div style={{ textAlign: "center", marginTop: "10px" }}>
        No games found.
      </div>
    ) : (
      <div style={{ textAlign: "center", marginTop: "10px" }}>
        No games available.
      </div>
    );
  }

  function renderContent() {
    if (props.game.loading) {
      return <CenteredLoader />;
    }
    return (
      <div>
        {searching ? <CenteredLoader /> : renderSearch()}
        {props.game.playing && (
          <div style={{ textAlign: "center", marginTop: "10px" }}>
            <p>You are on a game right now</p>
            {props.game.myPlayerId && props.game.info && (
              <LeaveGameButton
                myPlayerId={props.game.myPlayerId}
                gameId={props.game.info.id}
                gameName={props.game.info.gameName}
                text="Leave Game"
                leaveGame={props.leaveGame}
              />
            )}
          </div>
        )}
      </div>
    );
  }

  return (
    <div>
      <h4>Search Game</h4>
      <SearchInput
        onChange={handleSearchGame}
        placeholder="Search by game name.."
        onKeyDown={searchGamePress}
        value={search}
      />
      {renderContent()}
    </div>
  );
};

export default connector(SearchGame);
